import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useRef, useState } from 'react';
import { useHeaderLayoutStore } from '../../../shared';
export function useMobileMenu() {
  const $ = _c(8);
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null) as RefObject<HTMLButtonElement>;
  const isDesktopMenu = useHeaderLayoutStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openMenu = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeMenu = t1;
  let t2;
  let t3;
  if ($[2] !== isDesktopMenu) {
    t2 = () => {
      if (isDesktopMenu) {
        setIsOpen(false);
      }
    };
    t3 = [isDesktopMenu];
    $[2] = isDesktopMenu;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = isNowOpen => {
      if (isNowOpen) {
        return;
      }
      requestAnimationFrame(() => {
        const trigger = triggerRef.current;
        if (trigger?.getClientRects().length) {
          trigger.focus();
        }
      });
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleOpenChangeComplete = t4;
  let t5;
  if ($[6] !== isOpen) {
    t5 = {
      closeMenu,
      isOpen,
      handleOpenChangeComplete,
      openMenu,
      setIsOpen,
      triggerRef
    };
    $[6] = isOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(state) {
  return state.isDesktopMenu;
}